import axios from "../axios-private";

export function createCustomer(request) {
  return axios.post("/pelanggan/add", request);
}

export function editCustomer(id, request) {
  const concatRequest = Object.assign({ id: id }, request);
  return axios.post("/pelanggan/edit", concatRequest);
}

export function notifyCustomer(id, request) {
  const concatRequest = Object.assign({ id: id }, request);
  return axios.post("/pelanggan/notif", concatRequest);
}

export function deleteCustomer(id) {
  return axios.post("/pelanggan/delete", { id: id });
}

export function exportCustomer(request) {
  return axios.post("/pelanggan/list", request);
}